import { render, staticRenderFns } from "./GiftContent.vue?vue&type=template&id=1d8ad386"
import script from "./GiftContent.vue?vue&type=script&lang=js"
export * from "./GiftContent.vue?vue&type=script&lang=js"
import style0 from "./GiftContent.vue?vue&type=style&index=0&id=1d8ad386&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports